import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";

import { appRoutes } from "./routes";

/**
 * The browser entry point.
 *
 * Cloudflare Pages serves the built `dist/` statically and `public/_redirects`
 * rewrites every unknown path to `index.html`, so a deep link and a refresh
 * both land on this router rather than on a 404 from the edge.
 */
const router = createBrowserRouter(appRoutes);

export function App() {
  return <RouterProvider router={router} />;
}
